module.exports = __webpack_public_path__ + "static/img/jp1.c025c9ac.png";